module.exports = __webpack_public_path__ + "static/media/sidebar-bg.472d09fe.jpg";